import logo from "../../../../../assets/logo.png";
import { Icon } from "@iconify/react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  selectCurrentWeek,
  selectShowReview,
  selectShowHurray,
  selectCurrentPage,
  setCurrentWeek,
  setCurrentPage,
  setCurrentStep,
  setShowHurray,
  setShowReview,
} from "../../../../../redux/reducers/navigationSlice.js";
import "./index.css";
import { assessments, courseContent } from "./data";
// Import components
import PopUp from "./components/ReviewPopUp";
import Hurray from "./components/Hurray";

// Week 1
import TOT2PreAssesment from "./weeks/week1/preAssesement/PreAssesment.jsx";
import WeekOnePage2 from "./weeks/week1/page1/Page1";
import WeekOnePage3 from "./weeks/week1/page2/Page2";
import WeekOnePage4 from "./weeks/week1/page3/Page3";
import WeekOnePage5 from "./weeks/week1/page4/Page4";
import WeekOnePage6 from "./weeks/week1/page5/Page5";
import WeekOnePage7 from "./weeks/week1/page6/Page6";
import WeekOnePage8 from "./weeks/week1/page7/Page7";
import WeekOnePage9 from "./weeks/week1/page8/Page8";
import WeekOnePage10 from "./weeks/week1/page9/Page9";
import WeekOnePage11 from "./weeks/week1/page10/Page10";
import WeekOnePage12 from "./weeks/week1/page11/Page11";
import WeekOnePage13 from "./weeks/week1/page12/Page12.jsx";
import WeekOnePage14 from "./weeks/week1/page13/Page13.jsx";
import WeekOnePage15 from "./weeks/week1/page14/Page14.jsx";
import WeekOnePage16 from "./weeks/week1/page15/Page15.jsx";
import WeekOnePage17 from "./weeks/week1/page16/Page16.jsx";
import WeekOnePage18 from "./weeks/week1/page17/Page17.jsx";
import WeekOnePage19 from "./weeks/week1/page18/Page18.jsx";

// Week 2
import WeekTwoPage1 from "./weeks/week2/page1/Page1";
import WeekTwoPage2 from "./weeks/week2/page2/Page2";
import WeekTwoPage3 from "./weeks/week2/page3/Page3";
import WeekTwoPage4 from "./weeks/week2/page4/Page4";
import WeekTwoPage5 from "./weeks/week2/page5/Page5";
import WeekTwoPage6 from "./weeks/week2/page6/Page6.jsx";
import WeekTwoPage7 from "./weeks/week2/page7/Page7.jsx";
import WeekTwoPage8 from "./weeks/week2/page8/Page8.jsx";
import WeekTwoPage9 from "./weeks/week2/page9/Page9.jsx";
import WeekTwoPage10 from "./weeks/week2/page10/Page10.jsx";
import WeekTwoPage11 from "./weeks/week2/page11/Page11.jsx";
import WeekTwoPage12 from "./weeks/week2/page12/Page12.jsx";

// Week 3
import WeekThreePage1 from "./weeks/week3/page1/Page1";
import WeekThreePage2 from "./weeks/week3/page2/Page2";
import WeekThreePage3 from "./weeks/week3/page3/Page3.jsx";
import WeekThreePage4 from "./weeks/week3/page4/Page4.jsx";
import WeekThreePage5 from "./weeks/week3/page5/Page5.jsx";
import WeekThreePage6 from "./weeks/week3/page6/Page6.jsx";
import WeekThreePage7 from "./weeks/week3/page7/Page7.jsx";
import WeekThreePage8 from "./weeks/week3/page8/Page8.jsx";
import WeekThreePage9 from "./weeks/week3/page9/Page9.jsx";
import WeekThreePage10 from "./weeks/week3/page10/Page10.jsx";
import WeekThreePage11 from "./weeks/week3/page11/Page11.jsx";
import WeekThreePage12 from "./weeks/week3/page12/Page12.jsx";
import WeekThreePage13 from "./weeks/week3/page13/Page13.jsx";

// Week 4
import WeekFourPage1 from "./weeks/week4/page1/Page1.jsx";
import WeekFourPage2 from "./weeks/week4/page2/Page2.jsx";
import WeekFourPage3 from "./weeks/week4/page3/Page3.jsx";
import WeekFourPage4 from "./weeks/week4/page4/Page4.jsx";
import WeekFourPage5 from "./weeks/week4/page5/Page5.jsx";
import WeekFourPage6 from "./weeks/week4/page6/Page6.jsx";
import WeekFourPage7 from "./weeks/week4/page7/Page7.jsx";
import WeekFourPage8 from "./weeks/week4/page8/Page8.jsx";
import WeekFourPage9 from "./weeks/week4/page9/Page9.jsx";
import WeekFourPage10 from "./weeks/week4/page10/Page10.jsx";
import WeekFourPage11 from "./weeks/week4/page11/Page11.jsx";
import WeekFourPage12 from "./weeks/week4/page12/Page12.jsx";
import WeekFourPage13 from "./weeks/week4/page13/Page13.jsx";
import WeekFourPage14 from "./weeks/week4/page14/Page14.jsx";

// Week5
import WeekFivePage1 from "./weeks/week5/page1/Page1.jsx";
import WeekFivePage2 from "./weeks/week5/page2/Page2.jsx";
import WeekFivePage3 from "./weeks/week5/page3/Page3.jsx";
import WeekFivePage4 from "./weeks/week5/page4/Page4.jsx";
import WeekFivePage5 from "./weeks/week5/page5/Page5.jsx";
import WeekFivePage6 from "./weeks/week5/page6/Page6.jsx";
import WeekFivePage7 from "./weeks/week5/page7/Page7.jsx";
import WeekFivePage8 from "./weeks/week5/page8/Page8.jsx";
import WeekFivePage9 from "./weeks/week5/page9/Page9.jsx";
import WeekFivePage10 from "./weeks/week5/page10/Page10.jsx";
import WeekFivePage11 from "./weeks/week5/page11/Page11.jsx";
import WeekFivePage12 from "./weeks/week5/page12/Page12.jsx";
import WeekFivePage13 from "./weeks/week5/page13/Page13.jsx";
import WeekFivePage14 from "./weeks/week5/page14/Page14.jsx";

import { useEffect, useRef, useState } from "react";
import { useQueries, useQuery } from "@tanstack/react-query";
import userService from "../../../../../services/api/user.js";
import {
  updateData,
  userAnswer,
  clearData,
} from "../../../../../redux/reducers/userAnswersReducer.js";
import { adminData } from "../../../../../redux/reducers/adminReducer.js";

import { setCourse } from "../../../../../redux/reducers/navigationSlice.js";
import { logoutSuccess } from "../../../../../redux/reducers/userReducer.js";
import { clearToken } from "../../../../../redux/reducers/jwtReducer.js";

const tot2WeekNumbers = Object.keys(courseContent).map((weekKey) =>
  Number(weekKey.replace("week", "")),
);

const getTot2CourseDataQueryKey = (enrollmentId, week) => [
  "dashboard-tot2-course",
  enrollmentId,
  week,
];

const getTot2WeekTotalPages = (weekNumber) => {
  const weekKey = `week${weekNumber}`;
  const contentPages = courseContent[weekKey]?.pages?.length || 0;
  const hasAssessment = assessments[weekKey]?.questions?.length > 0;

  return Math.max(1, contentPages + (hasAssessment ? 1 : 0));
};

const clampTot2PageNumber = (pageNumber, totalPages) =>
  Math.max(1, Math.min(pageNumber, totalPages));

const mergeActivitiesByPage = (backendActivities = [], localActivities = []) => {
  const activitiesByPage = new Map();

  backendActivities.forEach((activity) => {
    activitiesByPage.set(Number(activity.page), activity);
  });

  localActivities.forEach((activity) => {
    activitiesByPage.set(Number(activity.page), activity);
  });

  return Array.from(activitiesByPage.values());
};

const getTot2ResumePageFromActivity = (activity, weekNumber) => {
  const totalPages = getTot2WeekTotalPages(weekNumber);
  const activities = activity?.activities || [];
  const hasSavedLastActivityIndex = Object.prototype.hasOwnProperty.call(
    activity || {},
    "lastActivityIndex",
  );
  const savedLastActivityIndex = Number(activity?.lastActivityIndex || 0);
  const answeredPages = new Set(
    activities
      .map((currentActivity) => Number(currentActivity.page || 0))
      .filter(Boolean),
  );
  const lastAnsweredPage = activities.reduce(
    (highestPage, currentActivity) =>
      Math.max(highestPage, Number(currentActivity.page || 0)),
    0,
  );
  const requiredActivityPages =
    courseContent[`week${weekNumber}`]?.pages
      ?.filter((page) => page.type !== "video")
      .map((page) => Number(page.id)) || [];
  const hasAnsweredAllActivities =
    requiredActivityPages.length > 0 &&
    requiredActivityPages.every((pageNumber) => answeredPages.has(pageNumber));

  if (savedLastActivityIndex > 1) {
    return clampTot2PageNumber(savedLastActivityIndex, totalPages);
  }

  if (hasAnsweredAllActivities) {
    return clampTot2PageNumber(totalPages, totalPages);
  }

  if (hasSavedLastActivityIndex && savedLastActivityIndex >= 1) {
    return clampTot2PageNumber(savedLastActivityIndex, totalPages);
  }

  if (lastAnsweredPage > 0) {
    return clampTot2PageNumber(lastAnsweredPage + 1, totalPages);
  }

  return null;
};

const WeekContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userAnswers = useSelector(userAnswer);
  const location = useLocation(); // Get location object
  const [enrollmentId, setEnrollmentId] = useState(null);
  const [course, setCourse] = useState(null);
  const [hasResolvedBackendResume, setHasResolvedBackendResume] =
    useState(false);
  const appliedBackendResumeWeekRef = useRef(null);
  const lastSavedActivitiesRef = useRef("[]");
  const { isAdmin } = useSelector(adminData);

  // Access data from location.state
  const enrolmentData = location.state?.enrollmentData; // Assuming enrollData is passed in state

  useEffect(() => {
    //toDo: Only Enrolled Users or Admin can access this course
    if (!enrolmentData && !isAdmin) return navigate("/sign-in");
    appliedBackendResumeWeekRef.current = null;
    lastSavedActivitiesRef.current = "[]";
    setHasResolvedBackendResume(false);
    setEnrollmentId(enrolmentData?._id);
    setCourse(enrolmentData?.course?._id);
  }, []);

  useEffect(() => {
    const currentWeek = sessionStorage.getItem("flow-currentWeek")
      ? Number(sessionStorage.getItem("flow-currentWeek"))
      : 1;
    const currentPage = sessionStorage.getItem("flow-currentPage")
      ? Number(sessionStorage.getItem("flow-currentPage"))
      : 1;
    const currentStep = sessionStorage.getItem("flow-currentStep")
      ? Number(sessionStorage.getItem("flow-currentStep"))
      : 1;

    // Dispatch the current week, page, and step
    dispatch(setCurrentWeek(currentWeek));
    dispatch(setCurrentPage(currentPage));
    dispatch(setCurrentStep(currentStep));

    return () => {};
  }, [dispatch]); // Added dispatch to dependency array

  const currentWeek = useSelector(selectCurrentWeek);
  const currentPage = useSelector(selectCurrentPage);
  const showReview = useSelector(selectShowReview);
  const showHurray = useSelector(selectShowHurray);

  // toDo: Fetch User assessment and Activity Data
  const { data, isLoading, status, isError } = useQuery({
    queryKey: getTot2CourseDataQueryKey(enrollmentId, currentWeek),
    queryFn: () => userService.getUserCourseData(enrollmentId, currentWeek),
    enabled: !!enrollmentId && !!currentWeek,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    keepPreviousData: false,
  });

  const resumePositionQueries = useQueries({
    queries: tot2WeekNumbers.map((weekNumber) => ({
      queryKey: getTot2CourseDataQueryKey(enrollmentId, weekNumber),
      queryFn: () => userService.getUserCourseData(enrollmentId, weekNumber),
      enabled: !!enrollmentId && !isAdmin,
      refetchOnMount: "always",
      refetchOnWindowFocus: true,
      staleTime: 0,
      gcTime: 0,
    })),
  });

  useEffect(() => {
    if (!enrollmentId) return;
    if (isAdmin) {
      setHasResolvedBackendResume(true);
      return;
    }
    if (appliedBackendResumeWeekRef.current) {
      setHasResolvedBackendResume(true);
      return;
    }
    if (resumePositionQueries.some((query) => query.isPending)) return;

    const resumeCandidates = resumePositionQueries
      .map((query, index) => {
        const weekNumber = tot2WeekNumbers[index];
        const activity = query.data?.activity;
        if (!activity) return null;

        const pageNumber = getTot2ResumePageFromActivity(
          activity,
          weekNumber,
        );
        if (!pageNumber) return null;

        return {
          weekNumber,
          pageNumber,
          updatedAt: activity.updatedAt
            ? new Date(activity.updatedAt).getTime()
            : 0,
        };
      })
      .filter(Boolean)
      .sort((firstCandidate, secondCandidate) => {
        if (secondCandidate.updatedAt !== firstCandidate.updatedAt) {
          return secondCandidate.updatedAt - firstCandidate.updatedAt;
        }

        if (secondCandidate.weekNumber !== firstCandidate.weekNumber) {
          return secondCandidate.weekNumber - firstCandidate.weekNumber;
        }

        return secondCandidate.pageNumber - firstCandidate.pageNumber;
      });

    const resumeTarget = resumeCandidates[0];
    if (!resumeTarget) {
      setHasResolvedBackendResume(true);
      return;
    }

    appliedBackendResumeWeekRef.current = resumeTarget.weekNumber;
    dispatch(setCurrentWeek(resumeTarget.weekNumber));
    dispatch(setCurrentPage(resumeTarget.pageNumber));
    dispatch(setCurrentStep(1));
    sessionStorage.setItem(
      "flow-currentWeek",
      resumeTarget.weekNumber.toString(),
    );
    sessionStorage.setItem(
      "flow-currentPage",
      resumeTarget.pageNumber.toString(),
    );
    sessionStorage.setItem("flow-currentStep", "1");
    setHasResolvedBackendResume(true);
  }, [dispatch, enrollmentId, isAdmin, resumePositionQueries]);

  useEffect(() => {
    if (!data) return;

    const canUseCurrentActivities =
      userAnswers.week === currentWeek &&
      userAnswers.courseEnrollmentId === enrollmentId;

    if (data.assessment && data.activity) {
      const backendActivities = data.activity?.activities || [];
      const activities = mergeActivitiesByPage(
        backendActivities,
        canUseCurrentActivities ? userAnswers.activities : [],
      );
      lastSavedActivitiesRef.current = JSON.stringify(backendActivities);
      dispatch(
        updateData({
          course: course,
          courseEnrollmentId: enrollmentId,
          week: currentWeek,
          activities,
          assessments: data.assessment?.assessments,
        }),
      );
    } else if (data.activity) {
      const backendActivities = data.activity?.activities || [];
      const activities = mergeActivitiesByPage(
        backendActivities,
        canUseCurrentActivities ? userAnswers.activities : [],
      );
      lastSavedActivitiesRef.current = JSON.stringify(backendActivities);
      dispatch(
        updateData({
          course: course,
          courseEnrollmentId: enrollmentId
            ? enrollmentId
            : userAnswers.courseEnrollmentId,
          week: currentWeek,
          activities,
          assessments: [],
        }),
      );
    } else {
      const activities = canUseCurrentActivities ? userAnswers.activities : [];
      lastSavedActivitiesRef.current = JSON.stringify([]);
      dispatch(
        updateData({
          course: course,
          courseEnrollmentId: enrollmentId
            ? enrollmentId
            : userAnswers.courseEnrollmentId,
          week: currentWeek,
          activities,
          assessments: [],
        }),
      );
    }

    return () => {};
  }, [data]);

  useEffect(() => {
    if (!hasResolvedBackendResume) return;
    if (!enrollmentId || !course || !currentWeek) return;
    if (data?.assessment) return;
    if (userAnswers.week !== currentWeek) return;
    if (userAnswers.courseEnrollmentId !== enrollmentId) return;
    if (!userAnswers.activities?.length) return;

    const activitiesJson = JSON.stringify(userAnswers.activities);
    if (activitiesJson === lastSavedActivitiesRef.current) return;

    const saveTimer = setTimeout(async () => {
      try {
        const result = await userService.postMyActivity(enrollmentId, {
          course,
          courseEnrollmentId: enrollmentId,
          week: currentWeek,
          activities: userAnswers.activities,
          lastActivityIndex: currentPage,
        });

        if (result?.success !== false) {
          lastSavedActivitiesRef.current = activitiesJson;
        }
      } catch (error) {
        console.error("Failed to save TOT2 activity progress", error);
      }
    }, 600);

    return () => clearTimeout(saveTimer);
  }, [
    course,
    currentPage,
    currentWeek,
    data?.assessment,
    enrollmentId,
    hasResolvedBackendResume,
    userAnswers.activities,
    userAnswers.courseEnrollmentId,
    userAnswers.week,
  ]);

  useEffect(() => {
    if (!hasResolvedBackendResume) return;
    if (!enrollmentId || !course || !currentWeek || !currentPage) return;
    if (data?.assessment) return;

    const saveTimer = setTimeout(async () => {
      try {
        const payload = {
          course,
          courseEnrollmentId: enrollmentId,
          week: currentWeek,
          lastActivityIndex: currentPage,
        };

        if (
          userAnswers.week === currentWeek &&
          userAnswers.courseEnrollmentId === enrollmentId &&
          userAnswers.activities?.length
        ) {
          payload.activities = userAnswers.activities;
        }

        await userService.postMyActivity(enrollmentId, payload);
      } catch (error) {
        console.error("Failed to save TOT2 resume position", error);
      }
    }, 800);

    return () => clearTimeout(saveTimer);
  }, [
    course,
    currentPage,
    currentWeek,
    data?.assessment,
    enrollmentId,
    hasResolvedBackendResume,
    userAnswers.activities,
    userAnswers.courseEnrollmentId,
    userAnswers.week,
  ]);

  // If showing hurray, render that instead
  if (showHurray) {
    return <Hurray currentWeek={currentWeek} />;
  }

  // Determine which component to render based on week and page
  const getComponent = () => {
    switch (currentWeek) {
      case 1:
        switch (currentPage) {
          case 1:
            return <TOT2PreAssesment />;
          case 2:
            return <WeekOnePage2 />;
          case 3:
            return <WeekOnePage3 />;
          case 4:
            return <WeekOnePage4 />;
          case 5:
            return <WeekOnePage5 />;
          case 6:
            return <WeekOnePage6 />;
          case 7:
            return <WeekOnePage7 />;
          case 8:
            return <WeekOnePage8 />;
          case 9:
            return <WeekOnePage9 />;
          case 10:
            return <WeekOnePage10 />;
          case 11:
            return <WeekOnePage11 />;
          case 12:
            return <WeekOnePage12 />;
          case 13:
            return <WeekOnePage13 />;
          case 14:
            return <WeekOnePage14 />;
          case 15:
            return <WeekOnePage15 />;
          case 16:
            return <WeekOnePage16 />;
          case 17:
            return <WeekOnePage17 />;
          case 18:
            return <WeekOnePage18 />;
          case 19:
            return <WeekOnePage19 />;
          default:
            return null;
        }
      case 2:
        switch (currentPage) {
          case 1:
            return <WeekTwoPage1 />;
          case 2:
            return <WeekTwoPage2 />;
          case 3:
            return <WeekTwoPage3 />;
          case 4:
            return <WeekTwoPage4 />;
          case 5:
            return <WeekTwoPage5 />;
          case 6:
            return <WeekTwoPage6 />;
          case 7:
            return <WeekTwoPage7 />;
          case 8:
            return <WeekTwoPage8 />;
          case 9:
            return <WeekTwoPage9 />;
          case 10:
            return <WeekTwoPage10 />;
          case 11:
            return <WeekTwoPage11 />;
          case 12:
            return <WeekTwoPage12 />;
          default:
            return null;
        }
      case 3:
        switch (currentPage) {
          case 1:
            return <WeekThreePage1 />;
          case 2:
            return <WeekThreePage2 />;
          case 3:
            return <WeekThreePage3 />;
          case 4:
            return <WeekThreePage4 />;
          case 5:
            return <WeekThreePage5 />;
          case 6:
            return <WeekThreePage6 />;
          case 7:
            return <WeekThreePage7 />;
          case 8:
            return <WeekThreePage8 />;
          case 9:
            return <WeekThreePage9 />;
          case 10:
            return <WeekThreePage10 />;
          case 11:
            return <WeekThreePage11 />;
          case 12:
            return <WeekThreePage12 />;
          case 13:
            return <WeekThreePage13 />;
          default:
            return null;
        }
      case 4:
        switch (currentPage) {
          case 1:
            return <WeekFourPage1 />;
          case 2:
            return <WeekFourPage2 />;
          case 3:
            return <WeekFourPage3 />;
          case 4:
            return <WeekFourPage4 />;
          case 5:
            return <WeekFourPage5 />;
          case 6:
            return <WeekFourPage6 />;
          case 7:
            return <WeekFourPage7 />;
          case 8:
            return <WeekFourPage8 />;
          case 9:
            return <WeekFourPage9 />;
          case 10:
            return <WeekFourPage10 />;
          case 11:
            return <WeekFourPage11 />;
          case 12:
            return <WeekFourPage12 />;
          case 13:
            return <WeekFourPage13 />;
          case 14:
            return <WeekFourPage14 />;
          default:
            return null;
        }
      case 5:
        switch (currentPage) {
          case 1:
            return <WeekFivePage1 />;
          case 2:
            return <WeekFivePage2 />;
          case 3:
            return <WeekFivePage3 />;
          case 4:
            return <WeekFivePage4 />;
          case 5:
            return <WeekFivePage5 />;
          case 6:
            return <WeekFivePage6 />;
          case 7:
            return <WeekFivePage7 />;
          case 8:
            return <WeekFivePage8 />;
          case 9:
            return <WeekFivePage9 />;
          case 10:
            return <WeekFivePage10 />;
          case 11:
            return <WeekFivePage11 />;
          case 12:
            return <WeekFivePage12 />;
          case 13:
            return <WeekFivePage13 />;
          case 14:
            return <WeekFivePage14 />;
          default:
            return null;
        }
      default:
        return null;
    }
  };

  return (
    <>
      {getComponent()}
      {showReview && <PopUp />}
    </>
  );
};

const CourseContent = () => {
  const { isAdmin } = useSelector(adminData);
  const currentWeek = useSelector(selectCurrentWeek);
  const currentPage = useSelector(selectCurrentPage);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const activeMenuItemRef = useRef(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const [enrollmentProgress, setEnrollmentProgress] = useState(0);
  const [maxAccessibleWeek, setMaxAccessibleWeek] = useState(1);
  const [enrollmentId, setEnrollmentId] = useState(null);
  const [expandedWeeks, setExpandedWeeks] = useState([currentWeek || 1]);
  const [maxReachedPages, setMaxReachedPages] = useState(() => {
    try {
      return (
        JSON.parse(sessionStorage.getItem("flow-tot2-maxReachedPages")) || {}
      );
    } catch {
      return {};
    }
  });

  const weeksTopic = [
    "Understanding Inclusion and Special Needs in the Classroom",
    "The Inclusive Mindset: Empathy and Compassion",
    "Designing Learning for Everyone, Universal Design for Learning and Differentiated Instruction",
    "Practical Strategies for Supporting Students with Common Special Needs",
    "Collaboration, Support Systems, and Inclusive Implementation",
  ];

  const tot2MenuLabels = {
    week1: {
      videos: [
        "Introduction Video",
        "Ideal Classroom",
        "Inclusive Classroom",
        "Segregation, Integration, Inclusion",
        "SEND",
        "Identify SEND Learners",
        "Empathy For SEND Learners",
        "Fairness in the Classroom",
        "Recap for the week",
      ],
      activitiesByPage: {
        1: "Pre-Assessment",
        3: "Activity 1",
        5: "Activity 2",
        7: "Activity 3",
        9: "Activity 4",
        11: "Activity 5",
        13: "Activity 6",
        15: "Activity 7",
        17: "Activity 8",
      },
    },
    week2: {
      videos: [
        "Focus for the Week",
        "Bias",
        "Teachers Awareness",
        "Strength-Based Thinking",
        "Empathy & Compassion",
        "Recap for the week",
      ],
    },
    week3: {
      videos: [
        "Focus for the Week",
        "UDL",
        "Engagement",
        "Representation",
        "Expression",
        "Recap for the week",
      ],
    },
    week4: {
      videos: [
        "Focus for the Week",
        "Intellectual Disability",
        "ASD",
        "ADHD",
        "Dyslexia",
        "Dysgraphia",
      ],
    },
    week5: {
      videos: [
        "Focus for the Week",
        "Collaboration",
        "How to Collaborate",
        "How to Collaborate (Cont.)",
        "IEP",
        "Teachers Wellbeing",
        "Dealing with Burnout",
      ],
    },
  };

  // Get enrollment data from location state
  const enrolmentData = location.state?.enrollmentData;
  const enrolmentCourseTitle = enrolmentData?.course?.title || "";
  const isTeaserCourse = enrolmentCourseTitle.includes("(Teaser Course)");
  const isExplicitPreview = location.state?.isPreview;
  const isPreview = isExplicitPreview || isTeaserCourse;
  const backToCoursesPath = isExplicitPreview
    ? "/school-dashboard/courses/all"
    : "/dashboard/my-courses";
  const isNavigationDisabled = isAdmin && !isPreview;

  useEffect(() => {
    if (!isPreview) return;

    sessionStorage.setItem("flow-course-preview-mode", "true");
    sessionStorage.setItem("flow-currentWeek", "1");
    sessionStorage.setItem("flow-currentPage", "1");
    sessionStorage.setItem("flow-currentStep", "1");
    dispatch(setCurrentWeek(1));
    dispatch(setCurrentPage(1));
    dispatch(setCurrentStep(1));
    dispatch(setShowHurray(false));
    dispatch(setShowReview(false));
    setMaxAccessibleWeek(1);

    return () => {
      sessionStorage.removeItem("flow-course-preview-mode");
      dispatch(clearData());
    };
  }, [isPreview, dispatch, weeksTopic.length]);

  // Capture enrollmentId from location state on mount
  useEffect(() => {
    if (enrolmentData?._id) {
      setEnrollmentId(enrolmentData._id);
    }
  }, []);

  // Fetch live enrollment data so progress bar stays up-to-date after each week
  const { data: liveEnrollment } = useQuery({
    queryKey: ["tot2-enrollment-progress", enrollmentId, currentWeek],
    queryFn: () => userService.getSingleEnrollment(enrollmentId),
    enabled: !!enrollmentId,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    // Prefer live server data; fall back to initial location.state snapshot
    const progress =
      liveEnrollment?.enrollment?.progress ??
      liveEnrollment?.progress ??
      enrolmentData?.progress ??
      0;

    setEnrollmentProgress(progress);

    // Calculate max accessible week based on progress
    const progressPerWeek = 100 / weeksTopic.length;
    const calculatedMaxWeek = Math.ceil(progress / progressPerWeek);

    // Allow access to current incomplete week + next week
    const accessibleWeek = Math.max(
      1,
      Math.min(calculatedMaxWeek + 1, weeksTopic.length),
    );
    setMaxAccessibleWeek(accessibleWeek);
  }, [liveEnrollment, enrolmentData]);

  useEffect(() => {
    if (!currentWeek || !currentPage) return;

    setMaxReachedPages((pages) => {
      const weekKey = `week${currentWeek}`;
      const nextPages = {
        ...pages,
        [weekKey]: Math.max(pages[weekKey] || 1, currentPage),
      };

      sessionStorage.setItem(
        "flow-tot2-maxReachedPages",
        JSON.stringify(nextPages),
      );

      return nextPages;
    });
  }, [currentWeek, currentPage]);

  useEffect(() => {
    if (!currentWeek || !currentPage) return;

    setExpandedWeeks([currentWeek]);

    const scrollTimer = setTimeout(() => {
      activeMenuItemRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }, 120);

    return () => clearTimeout(scrollTimer);
  }, [currentWeek, currentPage]);

  useEffect(() => {
    const segments = location.pathname.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    // This is an important section that affects course rendering!
    if (["tot_2"].includes(lastSegment?.toLowerCase())) {
      dispatch(setCourse(lastSegment.toLowerCase()));
    }
  }, [location.pathname, dispatch]);

  const handleWeekClick = (weekNumber) => {
    // Only allow navigation to completed weeks or the current week in progress
    if (weekNumber <= maxAccessibleWeek) {
      // Clear previous week data before switching
      if (weekNumber !== currentWeek) {
        dispatch(clearData());
      }
      dispatch(setShowHurray(false));
      dispatch(setShowReview(false));

      dispatch(setCurrentWeek(weekNumber));
      dispatch(setCurrentPage(1));
      dispatch(setCurrentStep(1));

      // Update session storage
      sessionStorage.setItem("flow-currentWeek", weekNumber.toString());
      sessionStorage.setItem("flow-currentPage", "1");
      sessionStorage.setItem("flow-currentStep", "1");
    }
  };

  const isWeekAccessible = (weekNumber) => {
    if (isPreview) return weekNumber === 1;
    return weekNumber <= maxAccessibleWeek;
  };

  const isWeekCompleted = (weekNumber) => {
    // A week is completed if the user has progressed beyond it
    const progressPerWeek = 100 / weeksTopic.length;
    return enrollmentProgress >= weekNumber * progressPerWeek;
  };

  const toggleWeekMenu = (weekNumber) => {
    if (!isWeekAccessible(weekNumber)) return;

    setExpandedWeeks((weeks) =>
      weeks.includes(weekNumber) ? [] : [weekNumber],
    );
  };

  const handleWeekHeaderClick = (weekNumber) => {
    toggleWeekMenu(weekNumber);
    if (weekNumber !== currentWeek) {
      handleWeekClick(weekNumber);
    }
  };

  const handleMenuItemClick = (weekNumber, pageNumber) => {
    if (!isMenuItemUnlocked(weekNumber, pageNumber)) return;

    if (weekNumber !== currentWeek) {
      dispatch(clearData());
    }

    dispatch(setShowHurray(false));
    dispatch(setShowReview(false));
    setExpandedWeeks([weekNumber]);
    dispatch(setCurrentWeek(weekNumber));
    dispatch(setCurrentPage(pageNumber));
    dispatch(setCurrentStep(1));

    sessionStorage.setItem("flow-currentWeek", weekNumber.toString());
    sessionStorage.setItem("flow-currentPage", pageNumber.toString());
    sessionStorage.setItem("flow-currentStep", "1");
  };

  const buildWeekMenuItems = (weekNumber) => {
    const weekKey = `week${weekNumber}`;
    const pages = courseContent[weekKey]?.pages || [];
    const labels = tot2MenuLabels[weekKey] || {};
    let videoCount = 0;
    let activityCount = 0;

    const items = pages.map((page) => {
      if (page.type === "video") {
        videoCount += 1;
        return {
          id: `${weekKey}-page-${page.id}`,
          pageNumber: page.id,
          type: "video",
          label: `Video ${videoCount}: ${
            labels.videos?.[videoCount - 1] || "Lesson"
          }`,
        };
      }

      activityCount += 1;
      return {
        id: `${weekKey}-page-${page.id}`,
        pageNumber: page.id,
        type: "activity",
        label:
          labels.activitiesByPage?.[page.id] || `Activity ${activityCount}`,
      };
    });

    if (assessments[weekKey]?.questions?.length) {
      items.push({
        id: `${weekKey}-assessment`,
        pageNumber: pages.length + 1,
        type: "assessment",
        label: `Week ${weekNumber} Assessment`,
      });
    }

    return items;
  };

  const isMenuItemCompleted = (weekNumber, pageNumber) => {
    if (isWeekCompleted(weekNumber)) return true;
    if (weekNumber < currentWeek) return true;

    const weekKey = `week${weekNumber}`;
    const maxReachedPage = Math.max(
      maxReachedPages[weekKey] || 1,
      weekNumber === currentWeek ? currentPage : 1,
    );

    return pageNumber < maxReachedPage;
  };

  const isMenuItemUnlocked = (weekNumber, pageNumber) => {
    if (!isWeekAccessible(weekNumber)) return false;
    if (isWeekCompleted(weekNumber)) return true;
    if (weekNumber < currentWeek) return true;
    if (weekNumber > currentWeek) return pageNumber === 1;

    const weekKey = `week${weekNumber}`;
    const maxReachedPage = Math.max(
      maxReachedPages[weekKey] || 1,
      weekNumber === currentWeek ? currentPage : 1,
    );

    return pageNumber <= maxReachedPage;
  };

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logoutSuccess());
    dispatch(clearToken());
    dispatch(
      updateData({
        course: null,
        courseEnrollmentId: null,
        week: 1,
        activities: [],
        assessments: [],
      }),
    );
    navigate("/sign-in", { replace: true });
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <button
            disabled={isNavigationDisabled}
            onClick={() => navigate("/dashboard")}
            className="navbar-logo"
            style={{ border: "none", background: "#FFF" }}
          >
            <img src={logo} alt="" />
          </button>
          <div
            className="navbar-logo d-none d-lg-block"
            onClick={logOut}
            style={{ cursor: "pointer" }}
          >
            Logout
          </div>

          <div className="d-block d-lg-none position-relative">
            <Icon
              icon="mdi:menu"
              width={30}
              onClick={toggleMenu}
              style={{
                cursor: "pointer",
              }}
            />
            {menuVisible && (
              <div
                className="d-lg-none position-absolute"
                style={{
                  top: "30px",
                  left: "-100px",
                  borderRadius: "15px",
                  border: "1px solid rgba(244, 241, 241, 0.9)",
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    overflow: "hidden",
                    borderRadius: "15px",
                    background: "rgba(255,255,255,0.9)",
                  }}
                  className="border-5 px-4 pt-4 pb-1"
                >
                  <ul className="d-flex gap-3 flex-column">
                    <li className="">
                      <Link to={"/dashboard"}>Overview</Link>
                    </li>
                    <li className="">
                      <Link to={"/dashboard/profile"}>Profile</Link>
                    </li>
                    <li className="">
                      <Link to={"/dashboard/my-courses"}>MyCourse</Link>
                    </li>
                    <li className="">
                      <Link to={"/dashboard/support"}>Support</Link>
                    </li>
                    <li className="text-nowrap">
                      <Link to={"/dashboard/payment-history"}>
                        Payment History
                      </Link>
                    </li>
                    <li className=" text-danger" onClick={logOut}>
                      Log Out
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      <div className="main-content flex-column-reverse flex-md-row">
        <aside className="d-md-none d-lg-block aside-class">
          <button
            disabled={isNavigationDisabled}
            onClick={() => navigate(backToCoursesPath)}
            className="back fs-6"
            style={{ cursor: "pointer", border: "none", background: "#f8f5f5" }}
          >
            <Icon icon="fa6-solid:arrow-left-long" className="me-2" />
            Back to My Courses
          </button>

          <div className="tot-title">
            <h2 className="fs-5 fs-md-3 tot-nav-text">
              Special Needs and Inclusive Education in Classrooms:
            </h2>
            <h2 className="compassion fs-5 tot-nav-text">
              Leaving No Learner Behind
            </h2>
          </div>

          <div className="transition-week-menu tot-week-menu">
            {weeksTopic.map((item, index) => {
              const weekNumber = index + 1;
              const isAccessible = isWeekAccessible(weekNumber);
              const isCompleted = isWeekCompleted(weekNumber);
              const isActive = weekNumber === currentWeek;
              const isExpanded = expandedWeeks.includes(weekNumber);
              const menuItems = buildWeekMenuItems(weekNumber);

              return (
                <div
                  key={index}
                  className={`transition-week-group ${
                    isActive ? "active-week" : ""
                  } ${isAccessible ? "accessible-week" : "locked-week"}`}
                >
                  <button
                    type="button"
                    className="transition-week-header"
                    onClick={() => handleWeekHeaderClick(weekNumber)}
                    disabled={!isAccessible}
                  >
                    <span
                      className={`transition-status-icon ${
                        isCompleted ? "completed" : isActive ? "active" : ""
                      }`}
                    >
                      <Icon icon={isAccessible ? "mdi:check" : "mdi:lock"} />
                    </span>
                    <span className="transition-week-heading">
                      <span className="transition-week-main">
                        Week {weekNumber}
                      </span>
                      <span className="transition-week-subtitle">{item}</span>
                    </span>
                    <Icon
                      icon="mdi:chevron-down"
                      className={`transition-week-chevron ${
                        isExpanded ? "expanded" : ""
                      }`}
                    />
                  </button>

                  <div
                    className={`transition-week-items ${
                      isExpanded ? "expanded" : ""
                    }`}
                  >
                    {menuItems.map((menuItem) => {
                      const itemActive =
                        currentWeek === weekNumber &&
                        currentPage === menuItem.pageNumber;
                      const itemCompleted = isMenuItemCompleted(
                        weekNumber,
                        menuItem.pageNumber,
                      );
                      const itemUnlocked = isMenuItemUnlocked(
                        weekNumber,
                        menuItem.pageNumber,
                      );

                      return (
                        <button
                          type="button"
                          key={menuItem.id}
                          ref={itemActive ? activeMenuItemRef : null}
                          className={`transition-week-item ${
                            itemActive ? "selected" : ""
                          } ${itemUnlocked ? "" : "locked"}`}
                          onClick={() =>
                            handleMenuItemClick(
                              weekNumber,
                              menuItem.pageNumber,
                            )
                          }
                          disabled={!itemUnlocked || !isExpanded}
                        >
                          <span
                            className={`transition-status-icon small ${
                              itemCompleted ? "completed" : ""
                            }`}
                          >
                            <Icon
                              icon={itemUnlocked ? "mdi:check" : "mdi:lock"}
                            />
                          </span>
                          <span>{menuItem.label}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Progress indicator */}
          <div className="mt-4 px-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-muted">Course Progress</small>
              <small className="fw-bold">{enrollmentProgress}%</small>
            </div>
            <div className="progress" style={{ height: "8px" }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${enrollmentProgress}%`,
                  backgroundColor: "#00BCC3",
                }}
                aria-valuenow={enrollmentProgress}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </aside>

        <aside
          className="d-none d-md-block d-lg-none"
          style={{
            flexBasis: "0px",
            background: "#00BCC3",
          }}
        >
          <button
            disabled={isNavigationDisabled}
            onClick={() => navigate(backToCoursesPath)}
            className="p-3"
            style={{
              cursor: "pointer",
              border: "none",
              background: "#f8f5f5",
              borderRadius: "50%",
            }}
          >
            <Icon icon="mdi:arrow-right" width="20" height="20" />
          </button>
        </aside>

        <section className="week-content resilience-week-content position-relative">
          <WeekContent />
        </section>
      </div>
    </>
  );
};

const TOTCourse = () => {
  return <CourseContent />;
};

export default TOTCourse;
